<template>
  <div class="reportTable">
    <section ref="print">
      <div class="mytitle">
        <ul>
          <li>
            <span>打印日期：</span>
            <span>{{ nowday }}</span>
          </li>
          <li>
            <span>打印时间：</span>
            <span>{{ nowtime }}</span>
          </li>
          <li>
            <span>酒店日期：</span>
            <span>{{ $parent.hotelInfo.dhoteltime }}</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span></span>
            <span>{{ $parent.hotelInfo.cname }}</span>
          </li>
          <li>
            <span></span>
            <span>{{ $parent.bbmc }}</span>
          </li>
          <li>
            <span>查询日期：</span>
            <span>
              {{ this.$moment(this.startDate).format("YYYY-MM-DD") }}
            </span>
            <span v-if="$parent.endTimeShow">
              至{{ this.$moment(this.endDate).format("YYYY-MM-DD") }}
            </span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>{{ $parent.userInfo.cname }}</span>
          </li>
          <!-- <li>
            <span>总页数:</span>
            <span>{{pagecount}}</span>
        </li>-->
          <li v-if="$parent.datacount > 0">
            <span>总条数:</span>
            <span>{{ $parent.datacount }}条</span>
          </li>
        </ul>
      </div>
      <div class="report">
        <table
          style="border-collapse: collapse"
          border="1"
          align="center"
          width="100%"
        >
          <thead>
            <tr>
              <th class="zhanghao">帐号</th>
              <th class="xingming">姓名</th>
              <th class="shijian">协议\会员</th>
              <th>备注</th>
              <th>房类</th>
              <th>房间号</th>
              <th style="text-align: right">定价</th>
              <th style="text-align: right">房价</th>
              <th>类型</th>
              <th class="fangjia">登记人</th>
              <!-- 
              <th style="text-align:right">折扣额</th>
              <th>类型</th>
              <th>登记人</th> -->
            </tr>
          </thead>
          <tbody>
            <template>
              <tr v-for="(item, index) in preArrivalList" :key="index">
                <td>{{ item.accNo }}</td>
                <td>{{ item.guestName }}</td>
                <td
                  v-if="
                    item.memberNo != '' &&
                    item.memberNo != null &&
                    item.memberNo != undefined
                  "
                >
                  {{ item.cardNo }}\{{ item.memberNo }}
                </td>
                <td v-else>
                  {{ item.customerName }}
                </td>
                <td>{{ item.remark }}</td>
                <td>{{ item.roomTypeName }}</td>
                <td>{{ item.roomName }}</td>

                <td style="text-align: right">{{ item.saleRate }}</td>
                <td style="text-align: right">{{ item.price }}</td>

                <td v-if="item.roomUseType == 'F'">普通</td>
                <td v-else-if="item.roomUseType == 'C'">免费</td>
                <td v-else-if="item.roomUseType == 'L'">长包</td>
                <td v-else-if="item.roomUseType == 'U'">内用</td>
                <td v-else-if="item.roomUseType == 'H'">钟点</td>
                <td v-else></td>
                <td>{{ item.operator }}</td>
              </tr>
              <tr>
                <td colspan="6">
                  合计:{{ preArrivalList.length }}条
                  <span style="margin-left: 50px"></span> 平均房价:
                  {{ $parent.curreny(average) }}
                  <!-- {{
                    average.toFixed(2)
                  }} -->
                </td>
                <td colspan="1">
                  {{ $parent.curreny(saletotal) }}

                  <!-- {{ saletotal.toFixed(2) }} -->
                </td>
                <td colspan="1">
                  {{ $parent.curreny(total) }}

                  <!-- {{ total.toFixed(2) }} -->
                </td>
                <td colspan="2"></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import { postRequest, getRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      preArrivalList: [],
      total: null,
      saletotal: null,
      average: null,
      // 记录
      room: 0,
      total: 0,
      allPage: 0,
      userName: localStorage.getItem("cname"),
      nowday:"",
      nowtime: "",
      startDate: "",
      endDate: ""
    };
  },
  created() {
    this.$parent.bbmc = "F19-1 当前在店宾客房价报表";
    this.$parent.startDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.endDate = this.$moment(new Date()).format("YYYY-MM-DD");
    this.$parent.closeshow();
    // this.$parent.isShow2 = false;
    this.$parent.startTimeShow = false;
    this.$parent.endTimeShow = false;
    this.$parent.chaxunvib = false;
    this.$parent.datetype = "月计划";
    this.getPreArrivalList();
  },
  methods: {
       curreny(data) {
      if (isNaN(data)) {
        let num = 0;
        return num.toFixed(2);
      } else if (data != null && data != undefined) {
        data = Number(data).toFixed(2);
        return data;
      }
    },
    dodayin() {
      this.$print(this.$refs.print);
    },
    doserach() {
      if (new Date(this.$parent.startDate) <= new Date(this.$parent.endDate)) {
        this.getPreArrivalList();
      } else {
        this.$mymessage({
          content: "截止日期必须大于开始日期",
          type: "error",
          time: 3000,
          hasClose: true,
        });
      }
    },

    getPreArrivalList() {
      let loadingInstance = this.$loading({ text: "正在查询..." });
      getRequest("/reportForFront/selectF191", {
        // startDate: this.$parent.startDate,
        // endDate: this.$parent.endDate,
      }).then((res) => {
        this.preArrivalList = [];

        this.$nextTick(() => {
          loadingInstance.close();
        }); //不回调
        if (res.status == 200) {
          this.$parent.datacount = res.data.length;
          this.$store.state.preArrivalList = res.data;
          this.$store.state.preArrivalName = "F19-1 当前在店宾客房价报表";
          this.preArrivalList = res.data;
          // console.log(222, this.preArrivalList);
          //   let total=null
          this.preArrivalList.forEach((item) => {
            this.total += item.price;
            this.saletotal += item.saleRate;
          });
          this.average = this.total / this.preArrivalList.length;
          // console.log(222, this.average);
          this.nowday= this.$moment(new Date()).format('YYYY-MM-DD');
          this.nowtime= this.$moment(new Date()).format('HH:mm:ss');
          this.startDate= this.$parent.startDate;
          this.endDate= this.$parent.endDate;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
table td,
table th {
  text-align: center;
  font-weight: normal;
}
.mytitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px !important;
  line-height: 24px;
  margin-bottom: 1em;
}
</style>
